<template>
  <textarea
    v-model="inputValue"
    :class="[{'spl-textarea--nomargin': nomargin}, {'spl-textarea--invalid': invalid}]"
    :name="name"
    :placeholder="placeholder"
    class="spl-textarea"
    @blur="$emit('blur')" />
</template>

<script>
export default {
  name: 'FormTextarea',
  props: {
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    index: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    nomargin: {
      type: Boolean,
      default: true
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputValue: this.value || ''
    }
  },
  computed: {
    isEmpty () {
      return this.inputValue === ''
    }
  },
  watch: {
    value (newVal, oldVal) {
      this.inputValue = newVal
    },
    inputValue: function (newVal, oldVal) {
      this.$emit('updateTextareaValue', newVal, this.index)
      this.$emit('input', newVal, this.index)
    }
  },
  methods: {
    inputOnChange () {}
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";

.spl-textarea {
  appearance: none;
  background-color: #fff;
  border: 1px solid $lightYellowBorder;
  color: $mainInputColor;
  font-family: $opensans;
  font-size: 14px;
  height: 100px;
  margin-bottom: $mainBottomMargin;
  padding: 10px 25px 10px 15px;
  resize: none;
  width: 100%;

  @include mobile() {
    font-size: 16px;
    height: 200px;
    margin-bottom: $mobileBottomMargin;
  }
  &--nomargin {
    margin-bottom: 0;
  }
  &--invalid {
    background-color: $redBackgroundLight;
    border-color: $errorRed;
  }
  &--valid {
    background-image: url(../../assets/icon-check.svg);
    background-position: right 7px center;
    background-repeat: no-repeat;
  }
  &[disabled] {
    opacity: 0.4;
  }
  &::-webkit-input-placeholder {
    color: $formPlaceholderColor;
  }
  &::-moz-placeholder {
    color: $formPlaceholderColor;
  }
  &:-ms-input-placeholder {
    color: $formPlaceholderColor;
  }
  &:-moz-placeholder {
    color: $formPlaceholderColor;
  }
}
</style>
